import { jsx as a } from "react/jsx-runtime";
import { useState as u } from "react";
import { chakra as i, Image as d } from "@chakra-ui/react";
import { useAvatarStyle as g } from "../Avatar.context.es.js";
import { AvatarName as p } from "./AvatarName.es.js";
const k = ({ src: o, boxSize: e, name: m, alt: n, trackId: t, ...v }) => {
  const r = g(), [c, f] = u(!1);
  return o && !c ? /* @__PURE__ */ a(
    i.div,
    {
      __css: r == null ? void 0 : r.avatarBox,
      backgroundColor: o ? "white" : "inherit",
      boxSize: e,
      children: /* @__PURE__ */ a(
        d,
        {
          __css: r.avatarImage,
          alt: n,
          onError: (h) => h && f(!0),
          src: o,
          "track-id": t ? `${t}-image` : void 0,
          ...v
        }
      )
    }
  ) : /* @__PURE__ */ a(
    i.div,
    {
      __css: r == null ? void 0 : r.avatarBox,
      backgroundColor: o ? "white" : "inherit",
      boxSize: e,
      children: /* @__PURE__ */ a(p, { name: m, trackId: t })
    }
  );
};
export {
  k as AvatarImage
};
//# sourceMappingURL=AvatarImage.es.js.map
